import { render, staticRenderFns } from "./news-item.vue?vue&type=template&id=1be8b96e&scoped=true&"
import script from "./news-item.vue?vue&type=script&lang=js&"
export * from "./news-item.vue?vue&type=script&lang=js&"
import style0 from "./news-item.vue?vue&type=style&index=0&id=1be8b96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be8b96e",
  null
  
)

export default component.exports